import { render } from "./Deals.vue?vue&type=template&id=8036eaf4&scoped=true"
import script from "./Deals.vue?vue&type=script&lang=js"
export * from "./Deals.vue?vue&type=script&lang=js"

import "./Deals.vue?vue&type=style&index=0&id=8036eaf4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8036eaf4"]])

export default __exports__